import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { ButtonComponent, ComponentsModule, InputComponent } from '@olympus/ngx-shared';
import { IconComponent } from 'shared-components/icon';

import { PcLicenseModalComponent } from './components/pc-license.component';

@NgModule({
  declarations: [PcLicenseModalComponent],
  imports: [
    CommonModule,
    FormsModule,
    InputComponent,
    ComponentsModule,
    ButtonComponent,
    IconComponent,
  ],
  exports: [PcLicenseModalComponent],
})
export class LicenseModule {
  public static forRoot(): ModuleWithProviders<LicenseModule> {
    return {
      ngModule: LicenseModule,
    };
  }

  public static forChild(): ModuleWithProviders<LicenseModule> {
    return {
      ngModule: LicenseModule,
    };
  }
}
